import {Injectable} from "@angular/core";
import {GapiUser} from "./gapiuser";
import {KaitoriyaConfig} from "../config/kaitoriya.config";
import {environment} from "../../environments/environment";

const CLIENT_ID = "970070305250-tnhp4kpftg7omnl3rv6m8li6oapj8515.apps.googleusercontent.com";
const KOBE_CLIENT_ID = "464669135320-i1pbjsf4e1ca63897mself1al6iare6q.apps.googleusercontent.com";
const API_KEY = "AIzaSyD_AG6R66RAmMFIZzzc0YbArjGOZxOzI9M";
const KOBE_API_KEY = "AIzaSyClbJLfoXYd6gWcmLJQXwMCUR_-QLnu1Uw";
const DISCOVERY_DOCS = ['https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest', 'https://sheets.googleapis.com/$discovery/rest?version=v4'];
let SCOPES = ['https://www.googleapis.com/auth/calendar', 'https://www.googleapis.com/auth/spreadsheets'].join(' ');

@Injectable()
export class GapiSession {
    googleAuth: gapi.auth2.GoogleAuth;

    // Google 連携の有効/無効 (environments)。OAuth client が origin を許可していない環境
    // (例: dev.kaitoriya.info) では init が失敗し画面動作を壊すため丸ごと無効化する。
    readonly enabled: boolean = (environment as any).googleEnabled !== false;

    constructor() {
    }

    initClient() {
        if (!this.enabled) {
            return Promise.resolve();
        }
        return new Promise<void>((resolve, reject) => {
            gapi.load('client:auth2', () => {
                return gapi.client.init({
                    apiKey: KaitoriyaConfig.production ? KOBE_API_KEY : API_KEY,
                    clientId: KaitoriyaConfig.production ? KOBE_CLIENT_ID : CLIENT_ID,
                    discoveryDocs: DISCOVERY_DOCS,
                    scope: SCOPES,
                }).then(() => {
                    this.googleAuth = gapi.auth2.getAuthInstance();
                    resolve();
                }, (err: any) => {
                    // init 失敗 (origin 未許可等) でもアプリ本体は動かす
                    console.error('gapi init failed', err);
                    resolve();
                });
            });
        });
    }

    isSignedIn(): boolean {
        if (!this.enabled || !this.googleAuth) {
            return false;
        }
        return this.googleAuth.isSignedIn.get();
    }

    signIn() {
        if (!this.enabled || !this.googleAuth) {
            return Promise.reject('google integration disabled');
        }
        return this.googleAuth.signIn({
            prompt: 'consent'
        }).then((googleUser: gapi.auth2.GoogleUser) => {
            localStorage.setItem("gapiuser", JSON.stringify(GapiUser.fromBasicProfile(googleUser.getBasicProfile())));
        });
    }

    signOut(): void {
        if (!this.enabled || !this.googleAuth) {
            return;
        }
        this.googleAuth.signOut();
        localStorage.removeItem("gapiuser");
    }
}
